export function stringIsEmpty(value) {
    let state = true

    if (value.toString()) {
        state = ['undefined', undefined, null, 'null', ''].includes(value.toString().trim())
    } else
        state = true

    return state

}


export function numberIsNotBiggerThanZero(number) {
    return ['undefined', null, 'null', '', 0, '0'].includes(number) || parseInt(number) <= 0
}

export function numberIsEmpty(number) {
    return ['undefined', null, 'null', '', 'Nan', 'NAN'].includes(number)
}

export function dateIsNotValid(date) {
    return ['undefined', null, 'null', '', 'Nan', 'NAN'].includes(date) || date.length !== 10
}